import type { IActivityRepository } from "@/application/ports/repositories";
import type {
  ActivityAggregates,
  ActivityFilters,
  ActivityList,
  ActivityListParams,
} from "@/domain/activity";
import type { ExportDownloadOptions, ExportPreview } from "@/domain/export";
import * as sdk from "../generated/sdk.gen";
import { unwrap, unwrapBlobWithFilename } from "../unwrap";
import { downloadBlob } from "../fileDownload";
export class ActivityRepository implements IActivityRepository {
  async list(params: ActivityListParams = {}, signal?: AbortSignal): Promise<ActivityList> {
    const { items, total_count } = await unwrap(sdk.listActivity({ query: params, signal }));
    return { events: items, total_count };
  }
  async getAggregates(
    filters: ActivityFilters = {},
    signal?: AbortSignal,
  ): Promise<ActivityAggregates> {
    return unwrap(sdk.aggregateActivity({ query: filters, signal }));
  }
  async previewExport(filters: ActivityFilters, signal?: AbortSignal): Promise<ExportPreview> {
    return unwrap(sdk.previewActivityExport({ query: filters, signal }));
  }
  async downloadExport(filters: ActivityFilters, options: ExportDownloadOptions): Promise<void> {
    const { blob, filename } = await unwrapBlobWithFilename(
      sdk.exportActivity,
      {
        query: {
          ...filters,
          format: options.format,
          columns: options.columns.length ? options.columns.join(",") : undefined,
        },
      },
      `activity.${options.format}`,
    );
    downloadBlob(blob, filename);
  }
}
